export default __webpack_public_path__ + "static/media/b8.56ba2f65.jpg";